import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import ErrorBoundary from '../../errorboundary';
import InputNumberItem from '../inputnumberitem';

const Option = Select.Option;

const SelectWorkflowForm = (props) => {
    const { title, title_class, container_class, workflow_container, workflow_title, workflow_title_class, workflow_select_class, workflow_placeholder, workflows, wid, onChangeWorkflow, hide_node, node_container, node_title, node_title_class, node_select_class, node_placeholder, nodeId, onChangeNode, show_node_visit, node_visit_title, node_visit_placeholder, node_visit, onChangeNodeVisit } = props;

    return (
        <div className={container_class}>
            {
                title &&
                <p className={`ori-t-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
            }
            <ErrorBoundary>
                <div className={workflow_container}>
                    <p className={`ori-b-mrgn-5 ori-capitalize-first ${workflow_title_class}`}>{workflow_title}</p>
                    <Select showSearch className={workflow_select_class} placeholder={workflow_placeholder} optionFilterProp="children" filterOption={(input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} value={wid} onChange={onChangeWorkflow} >
                        {
                            workflows && workflows.map((workflow) => {
                                return (
                                    <Option key={workflow.wid} value={workflow.wid}>{workflow.name}</Option>
                                );
                            })
                        }
                    </Select>
                </div>
            </ErrorBoundary>
            {
                !hide_node &&
                <ErrorBoundary>
                    <div className={node_container}>
                        <p className={`ori-b-mrgn-5 ori-capitalize-first ${node_title_class}`}>{node_title}</p>
                        <Select showSearch className={node_select_class} placeholder={node_placeholder} optionFilterProp="children" filterOption={(input, option) => option.props.children && option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} value={nodeId} onChange={onChangeNode} >
                            {
                                wid && workflows &&
                                workflows.find((workflow) => { return (workflow.wid === wid) }).nodes.map((node) => {
                                    return (
                                        <Option key={node.nodeId} value={node.nodeId}>{node.name}</Option>
                                    );
                                })
                            }
                        </Select>
                    </div>
                </ErrorBoundary>
            }
            {
                show_node_visit &&
                <ErrorBoundary>
                    <InputNumberItem container_class="ori-t-pad-10 ori-flex-row" title_class="ori-r-mrgn-15 ori-t-pad-5" min={0} title={node_visit_title} placeholder={node_visit_placeholder} value={node_visit} onChange={onChangeNodeVisit} />
                </ErrorBoundary>
            }
        </div>
    );
};

SelectWorkflowForm.propTypes = {
    title: PropTypes.string,
    title_class: PropTypes.string,
    container_class: PropTypes.string,
    workflow_container: PropTypes.string,
    workflow_title: PropTypes.string,
    workflow_title_class: PropTypes.string,
    workflow_select_class: PropTypes.string,
    workflow_placeholder: PropTypes.string,
    workflows: PropTypes.array.isRequired,
    wid: PropTypes.number,
    onChangeWorkflow: PropTypes.func,
    node_container: PropTypes.string,
    node_title: PropTypes.string,
    node_title_class: PropTypes.string,
    node_select_class: PropTypes.string,
    node_placeholder: PropTypes.string,
    nodeId: PropTypes.number,
    onChangeNode: PropTypes.func,
    show_node_visit: PropTypes.bool,
    hide_node: PropTypes.bool,
    node_visit_title: PropTypes.string,
    node_visit_placeholder: PropTypes.string,
    node_visit: PropTypes.number,
    onChangeNodeVisit: PropTypes.func,
};

SelectWorkflowForm.defaultProps = {
    conatiner_class: "ori-tb-pad-5",
    workflow_container: "ori-tb-pad-7",
    workflow_title: "workflow",
    workflow_select_class: "ori-full-width",
    workflow_placeholder: "Select workflow",
    node_container: "ori-tb-pad-7",
    node_title: "node",
    node_select_class: "ori-full-width",
    node_placeholder: "Select Node",
    show_node_visit: false,
    hide_node: false,
    node_visit_title: "Node visits",
    node_visit_placeholder: "Count"
};

export default SelectWorkflowForm;



// WEBPACK FOOTER //
// ./src/components/form/selectworkflowform/index.js